import React, { useState } from "react"
import { gql, useMutation } from "@apollo/client"

import SendEmailModal from "components/Common/Forms/SendEmailModal"
import { Popover } from "@headlessui/react"

import { useAuth } from "hooks/useAuth"

import formatDate from "utils/formatDate"

import cn from "classnames"

import ReactTooltip from "react-tooltip"

import { toast } from "react-hot-toast"

const ENV = process.env.NODE_ENV
const DEV_URL = `http://localhost:3000`
const PROD_URL = `https://grouptravelres.com/`
const BASE_URL = ENV === "development" ? DEV_URL : PROD_URL

const GENERATE_TRIP_REPORT = gql`
  mutation GenerateTripReport($id: ID!) {
    generateTripReport(id: $id)
  }
`

const Hero = ({
  id,
  code,
  name,
  image,
  status,
  startDate,
  endDate,

  destinations,
  slug,
  isPublishable,

  children,
  onDelete,
  onExportCSV,
  onExportPDF,
  updateTripStatus,
}) => {
  const { role, token } = useAuth()
  const PREVIEW_URL = `${BASE_URL}/api/preview?secret=${token}&slug=${slug}`
  const PUBLISHED_URL = `${BASE_URL}/api/reset-preview?slug=${slug}`

  const PAGE_URL = `${BASE_URL}/trips/${slug}`

  const URL = status === "PUBLISHED" ? PUBLISHED_URL : PREVIEW_URL

  const handleDelete = async () => {
    // if (window.confirm("Are you sure you want to delete this trip?")) {
    // }
    if (
      window.prompt(
        "Are you sure you want to delete this trip? Type YES to confirm",
      ) === "YES"
    ) {
      await onDelete(id)
    }
  }

  const createTripReport = async () => {
    try {
      await toast.promise(
        fetch(`${uri}/reporting/group/xlsx/${id}`)
          .then((_) => _.blob())
          .then((blob) => {
            const file = window.URL.createObjectURL(blob)
            window.location.assign(file)
          }),
        {
          loading: "Creating report...",
          success: <b>Report created!</b>,
          error: <b>Could not save.</b>,
        },
      )
    } catch (error) {}
  }

  const createTripPDF = async () => {
    try {
      await toast.promise(
        fetch(`${uri}/reporting/group/pdf/${slug}`, {})
          .then((_) => _.blob())
          .then((blob) => {
            // const blob = new Blob([response.data], {type: 'application/pdf'})
            const link = document.createElement("a")
            link.href = window.URL.createObjectURL(blob)
            link.download = `${name}.pdf`
            link.click()
            // const file = window.URL.createObjectURL(blob)
            // window.location.assign(file)
          }),
        {
          loading: "Creating PDF...",
          success: <b>Report created!</b>,
          error: <b>Could not save.</b>,
        },
      )
    } catch (error) {}
  }

  const sendEmail = async (data) => {}

  const [isOpen, setIsOpen] = useState(false)
  const openModal = () => setIsOpen(true)

  //TODO: move to mappwing
  const ENV = process.env.NODE_ENV
  const DEV_URL = "http://localhost:4000"
  const PROD_URL = "https://us-central1-grouptravelres.cloudfunctions.net/api"
  const uri = ENV === "development" ? DEV_URL : PROD_URL
  // const uri = PROD_URL

  const location = destinations?.map((_) => _?.name)?.join(", ")
  const startDateFormated = formatDate(startDate, "dd. MMMM yyyy")
  const endDateFormated = formatDate(endDate, "dd. MMMM yyyy")
  const EMAIL_BODY = `Dear,
We are inviting you to join us on ${name}.
We will be visiting ${location} from ${startDateFormated} until ${endDateFormated}.
You can find more information on ${PAGE_URL}
`

  return (
    <>
      <div className="w-full relative">
        <div className="absolute inset-0 h-full w-full z-10 bg-gradient-to-t from-transparent to-black">
          <div className="max-w-screen-xl mx-auto px-4 sm:px-6 lg:px-8 pt-3">
            <div className="flex justify-between">
              <div className="flex-1">
                <div className="mt-1 flex items-center space-x-4">
                  <p className="bg-indigo-200 text-indigo-800 px-2 py-1 inline-block leading-normal rounded-lg  font-semibold uppercase tracking-wide text-xs">
                    {code}
                  </p>

                  <p className="text-xs text-gray-300 font-semibold uppercase tracking-wide leading-normal">
                    {`${formatDate(startDate, "dd. MMM")} - ${formatDate(
                      endDate,
                      "dd. MMM yyyy",
                    )}`}
                  </p>

                  <p className="text-xs text-gray-300 font-semibold uppercase tracking-wide leading-normal">
                    {location}
                  </p>
                </div>

                <div className="flex items-center text-gray-100">
                  <h1 className="mt-1 font-semibold text-4xl leading-normal">
                    {name}
                  </h1>

                  <div className="ml-4  leading-normal flex space-x-4">
                    <a
                      className="flex space-x-2 items-center hover:text-blue-500"
                      href={PREVIEW_URL}
                      target="_tab"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="h-5 w-5"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z"
                        />
                      </svg>
                    </a>

                    <a
                      className="flex space-x-2 items-center hover:text-blue-500"
                      href={PUBLISHED_URL}
                      target="_tab"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="h-6 w-6"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14"
                        />
                      </svg>

                      {/* <span className="text-xs uppercase">
                        {status === "PUBLISHED" ? "View" : "Edit"}
                      </span> */}
                    </a>
                  </div>
                </div>
              </div>

              <div className="w-2/12 flex flex-col  items-end pt-1">
                <div data-tip="Please add products in order to publish trip">
                  <Popover className="relative">
                    <Popover.Button
                      className={cn(
                        `text-white text-xs font-bold py-2 px-4 rounded-full flex space-x-2`,
                        {
                          [`bg-green-500 hover:bg-green-800`]:
                            status === "PUBLISHED",
                          [`bg-yellow-500 hover:bg-yellow-800`]:
                            status === "CREATED",
                          [`bg-yellow-500 hover:bg-yellow-800`]:
                            status === "DRAFT",
                          [`bg-blue-500 hover:bg-blue-800`]:
                            status === "PENDING",
                        },
                      )}
                    >
                      {" "}
                      <span>{status}</span>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        class="h-4 w-4"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                      >
                        <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="2"
                          d="M19 9l-7 7-7-7"
                        />
                      </svg>
                    </Popover.Button>

                    <Popover.Panel className="absolute z-50 right-0 px-4 mt-3  sm:px-0 lg:max-w-xs w-48">
                      <div className="overflow-hidden rounded-lg shadow-lg ring-1 ring-black ring-opacity-5">
                        <div className="relative z-50 flex flex-col bg-white">
                          {["DRAFT", "PUBLISHED"]
                            .filter((_) => _ !== status)
                            .map((status, index) => (
                              <button
                                disabled={
                                  status === "PUBLISHED" && !isPublishable
                                }
                                className="text-xs flex items-center space-x-4 hover:bg-blue-500 hover:text-white p-4 disabled:opacity-50 disabled:cursor-wait"
                                key={index}
                                onClick={() => updateTripStatus(status)}
                              >
                                {/* <i className="block mr-4">{option?.icon}</i> */}
                                {status}
                              </button>
                            ))}
                        </div>
                      </div>
                    </Popover.Panel>
                  </Popover>
                </div>
              </div>
            </div>

            {!isPublishable && (
              <ReactTooltip place="left" type="info" effect="solid" />
            )}

            <div className="mt-4 flex justify-between items-center">
              <div>{children}</div>
              <nav className="flex items-start justify-end space-x-6 pt-2">
                {/* <button className="text-gray-200 hover:text-blue-500">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-5 w-5"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M13.828 10.172a4 4 0 00-5.656 0l-4 4a4 4 0 105.656 5.656l1.102-1.101m-.758-4.899a4 4 0 005.656 0l4-4a4 4 0 00-5.656-5.656l-1.1 1.1"
                    />
                  </svg>
                </button> */}

                <button
                  className="text-gray-200 hover:text-blue-500"
                  onClick={openModal}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-5 w-5"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      stroke-width="2"
                      d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
                    />
                  </svg>
                </button>

                <button
                  className="text-gray-200 hover:text-blue-500"
                  onClick={createTripReport}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-5 w-5"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      stroke-width="2"
                      d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M9 19l3 3m0 0l3-3m-3 3V10"
                    />
                  </svg>
                </button>

                <button
                  className="text-gray-200 hover:text-blue-500"
                  onClick={createTripPDF}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-5 w-5"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      stroke-width="2"
                      d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                    />
                  </svg>
                </button>

                {role === "ADMIN" && (
                  <button
                    className="text-red-500 hover:text-red-300"
                    onClick={handleDelete}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="h-5 w-5"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
                      />
                    </svg>
                  </button>
                )}
              </nav>
            </div>
          </div>
        </div>

        <div className="relative h-64">
          <img
            src={image?.url}
            alt=""
            className="absolute inset-0 h-full w-full object-cover"
          />
        </div>
      </div>

      <SendEmailModal
        bcc
        initialValues={{
          subject: "Join us on new adventure",
          body: EMAIL_BODY,
          template: "GROUP_PROMO",
        }}
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        onSubmit={sendEmail}
      />
    </>
  )
}

export default Hero
